<template>
	<v-container>
		<div>
			<v-row v-if="feedback == 0" class="contentRow">
				<v-col cols="12" class="pl-15 pr-15">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="addFeedback()" style="border: 1px solid ;" v-if="!isFeedbackGiven">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="75" class="mx-auto my-8" />
					<h2 class="text-center font-weight-medium">Thank You for submitting the Orixe audit questionary!</h2>
				</v-col>
				<v-col cols="12" class="pr-15 pl-15">
					<p>At Orixe, we believe that ethical supply chains are the foundation of a sustainable future. By fostering transparency and trust, we enable businesses to not only
					meet today's demands for accountability but also lead the way in creating a positive legacy for people and the planet.</p>
				</v-col>
				<v-col cols="12" align="center">
					<v-btn outlined class="ma-2 white--text" color="primary" @click="seeOverview">OVERVIEW OF MY ANSWERS</v-btn>
					<!--<v-btn dark color="orangeButton" class="ma-2" @click="getFreeAcc()">GET A FREE TRAIL</v-btn>-->
				</v-col>
			</v-row>
			<v-row v-if="feedback == 1" class="contentRow">
				<v-col cols="12" class="pl-15 pr-15">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="cancelFeedback()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<h2 class="mb-5">We'd love your feedback!</h2>
					<p>At Orixe, we're driven by a mission to make supply chains more transparent, ethical and sustainable. Our goal is to empower businesses to take control of 
					their supply chains while upholding the highest standards of responsibility and efficiency.</p>
					<p>Your feedback helps us create the best and most user-friendly solution for auditing suppliers and managing supply chain performance. Let us know what worked well,
					what could be improved, or any ideas you have -- we're listening</p>
					<p class="primary--text"><i>Thank you for being part of this journey toward better business practices.</i></p>
				</v-col>
				<v-col class="pl-15 pr-15" align="right">
					<!--<v-btn dark color="orangeButton" class="ma-2" @click="getFreeAcc()">GET A FREE TRAIL</v-btn>-->
				</v-col>
				<v-col cols="12" align="center">
					<p>How was your overall experience using the Orixe platform?</p>
				</v-col>
				<v-col cols="12" align="center">
					<v-btn icon :color="platform === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
					<v-btn icon :color="platform === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
					<v-btn icon :color="platform === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
					<v-btn icon :color="platform === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
					<v-btn icon :color="platform === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="platformComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
					<v-dialog v-model="commentBoxOpen" persistent max-width="600">
						<v-card>
							<v-col>
								<v-card-title>How was is to navigate in the platform?</v-card-title>
								<v-btn icon :color="navigation === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
								<v-btn icon :color="navigation === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
								<v-btn icon :color="navigation === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
								<v-btn icon :color="navigation === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
								<v-btn icon :color="navigation === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="navigationComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
							</v-col>
							<v-col>
								<v-card-title>How was your experience completing the task?</v-card-title>
								<v-btn icon :color="task === 1 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(1)" large><v-icon large>far fa-sad-tear</v-icon></v-btn>
								<v-btn icon :color="task === 2 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(2)" large><v-icon large>far fa-frown</v-icon></v-btn>
								<v-btn icon :color="task === 3 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(3)" large><v-icon large>far fa-meh</v-icon></v-btn>
								<v-btn icon :color="task === 4 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(4)" large><v-icon large>far fa-smile</v-icon></v-btn>
								<v-btn icon :color="task === 5 ? 'orangeButton' : 'primary'" class="ma-8" @click="taskComment(5)" large><v-icon large>far fa-laugh</v-icon></v-btn>
							</v-col>
							<v-col>
								<v-card-title>Do you have any suggestions for improvement?</v-card-title>
								<v-card-text>
									<!-- Your comment box content goes here -->
									<v-textarea v-model="comment"></v-textarea>
								</v-card-text>
							</v-col>
							<!-- <v-icon :class="computedIconClass1" icon color="primary" class="ma-8" large>fa-sad-tear</v-icon>
							<v-icon :class="computedIconClass2" icon color="primary" class="ma-8" large>fa-frown</v-icon>
							<v-icon :class="computedIconClass3" icon color="primary" class="ma-8" large>fa-meh</v-icon>
							<v-icon :class="computedIconClass4" icon color="primary" class="ma-8" large>fa-smile</v-icon>
							<v-icon :class="computedIconClass5" icon color="primary" class="ma-8" large>fa-laugh</v-icon> -->
				
							<v-card-actions>
								<v-btn @click="submitComment" color="primary">Submit</v-btn>
								<v-btn @click="commentBoxOpen = false" color="primary">Cancel</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
			</v-row>
			<v-row v-else-if="feedback == 2" class="contentRow pr-15 pl-15">
				<v-col cols="12" class="pl-15 pr-15">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="cancelFeedback()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<v-img alt="Success Icon" :src="require('../../assets/twemoji/success.svg')" width="70" class="mx-auto my-8" />
					<h2 class="mb-5">Thank You for Your Feedback!</h2>
					<p>We truly appreciate you taking the time to share your thoughts. Your input helps us make Orixe more effective and user-friendly.</p>
					<p>At Orixe, we believe transparency and accountability are essntial for a better future.</p>
					<p>Supply chains impact the environment, human rights, and resources -- but often lack the visibility needed for responsible management.</p>
					<p>Together we're working towards ethical, sustainable supply chains that build trust and drive progress.</p>
					<p>Thank you for being part of this journey!</p>
				</v-col>
				<v-col cols="12" align="center">
					<v-btn class="ma-2 white--text" color="primary" to="/account">UPGRADE MY ACCOUNT</v-btn>
				</v-col>
			</v-row>
			<v-dialog v-model="exitDialog" max-width="700">
				<v-card cols="12" class="pa-10">
					<v-card-actions class="justify-end">
						<v-icon class="pl-1 pr-1" color="primary" @click="cancelExit()" style="border: 1px solid ;">fas fa-thin fa-times</v-icon>
					</v-card-actions>
					<p>"At Orixe, we believe businesses are the world's most influential institutions. Their decisions shape supply chains, 
						communities, and ecosystems, impacting lives and economies. However, the complexity of global supply chains often makes it 
						challenging to ensure ethical practices and minimize environmental harm.</p>
					<p>We believe this challenge can be addressed by combining advanced technology with core values like integrity, accountability, and fairness, 
						enabling organizations to act decisively and effectively."</p>
				</v-card>
			</v-dialog>
		</div>
	</v-container>
</template>
<script>
import RequestAPI from "../../api/audit/request"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "SuccessfulSubmissionView",
	data() {
		return {
			commentBoxOpen: false,
			comment: "",
			num: null,
			feedback: 0,
			exitDialog: false,
			navigation: null,
			platform: null,
			task: null,
			isFeedbackGiven: false
		}
	},
	computed: {
		computedIconClass1() {
			// Conditionally return the appropriate icon class based on your logic
			return this.num === 1 ? "fas fa-sad-tear" : "far fa-sad-tear"
		},
		computedIconClass2() {
			return this.num === 2 ? "fas fa-frown" : "far fa-frown"
		},
		computedIconClass3() {
			return this.num === 3 ? "fas fa-meh" : "far fa-meh"
		},
		computedIconClass4() {
			return this.num === 4 ? "fas fa-smile" : "far fa-smile"
		},
		computedIconClass5() {
			return this.num === 5 ? "fas fa-laugh" : "far fa-laugh"
		},
	},
	mounted() {
		this.getFeedbackData()
	},
	methods: {
		seeOverview() {
			let id = this.$route.params.id
			this.$router.push(`/auditonsite/onsiteauditor/${id}`)
		},
		platformComment(selected) {
			this.platform = selected
			this.commentBoxOpen = true

		},
		navigationComment(selected) {
			this.navigation = selected
		},
		taskComment(selected) {
			this.task = selected
		},
		closeCommentBox() {
			this.commentBoxOpen = false
		},
		getFeedbackData(){
			let currentTime = new Date()
			RequestAPI.getFeedback()
				.then(result => {
					for (let entry of result) {
						if( entry.Module == 1){
							let submittedTime = new Date(entry.SubmitTime)
							let different = Math.floor((currentTime - submittedTime) / (1000 * 60 * 60 * 24))

							if(different < 60){
								this.isFeedbackGiven = true
							}
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		submitComment() {
			let id = this.$route.params.id
			let submitTime = new Date().toISOString().slice(0, 19).replace("T", " ")
			let module = this.$route.path.split("/")[1]
			
			RequestAPI.submitFeedback(id,submitTime,this.platform,this.navigation,this.task,this.comment,module)
				.then( () => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully submit the feedback`,
						{ root: true }
					)
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			this.commentBoxOpen = false
			this.feedback = 2
		},
		addFeedback(){
			this.feedback = 1
		},
		cancelFeedback(){
			this.exitDialog = true
		},
		cancelExit(){
			this.exitDialog = false
			this.$router.push("/")
		},
		getFreeAcc(){
			this.$router.push("/account")
		}
		/* notNow(){
			this.feedback = 2
		},
		byePage(){
			this.feedback = 3
		} */
	}
}
</script>